<span class="m-b-10 display-block"
  >Peer State: {{ peerState }}

  @if (mainPlayerId) {
    <a class="pointer" (click)="onKillPixi(mainPlayerId)">💀</a>
  }
</span>
<div class="flex gap-10 m-b-14">
  <button mat-raised-button color="warn" (click)="onClosePublishPeer()">Close PublishPeer</button>
  <button mat-raised-button color="accent" (click)="onRepublish()">Republish</button>
  <button mat-raised-button color="accent" (click)="onPeerFail()">Simulate Peer Media Failure</button>
</div>
<app-select placeholder="Select a Room" [(value)]="selectedSubscriptionType" style="margin-bottom: 10px">
  <app-select-option [label]="'ALL'" [value]="'ALL'" (selected)="onSelectionChange('ALL')"></app-select-option>
  @for (type of subscriptionTypes; track type) {
    <app-select-option [label]="type" [value]="type" (selected)="onSelectionChange(type)"></app-select-option>
  }
</app-select>
@for (subscription of filteredSubscriptions; track subscription) {
  <div class="flex justify-between items-center">
    <span class="m-r-20"
      >{{ subscription.name }} {{ subscription.peerTime }} {{ getReason(subscription?.reason) }}</span
    >
    <div>
      @if (subscription.videoNeeded) {
        <span> 🎥 </span>
      }
      @if (subscription.audioNeeded) {
        <span>🔈</span>
      }
      {{ subscription.state }}
      @if (subscription.state === SubscriptionState.SUBSCRIBED) {
        <a class="pointer" (click)="onCloseSubscriberPeer(subscription)">❌</a>
      }
      <a class="pointer" (click)="onKillPixi(subscription)">💀</a>
    </div>
  </div>
}
